import { message } from 'antd';

import { Modal } from 'antd';

export default () => {
  const [modal, modalContextHolder] = Modal.useModal();
  const [messageApi, messageApiHolder] = message.useMessage();

  return {
    modal,
    messageApi,
    modalContextHolder,
    messageApiHolder,
  };
};
